export default __webpack_public_path__ + "static/media/infoRounded.49d8ce3e.svg";